import { minutesAmount, minuteText } from './snackbar-text-helpers.js';

export default function SnackbarText({ minutes }: { minutes: number }) {
  return (
    <>
      <p className="mb-3 font-bold">Tidsgräns snart uppnådd</p>
      <p>
        Om {minutesAmount(minutes)} {minuteText(minutes)} uppnår du din dagliga tidsgräns. När du nått din tidsgräns kan
        du inte betala spel eller sätta in pengar.
      </p>
    </>
  );
}
